import { useRoute } from '@react-navigation/native';

/**
 * Hook to determine if the current route is the MultiplayerResults screen.
 * Returns true if on MultiplayerResults, false otherwise.
 */
export function useOnMultiplayerResultsScreen() {
  const route = useRoute();
  // Route name may be 'MultiplayerResults' or nested, adjust as needed
  return route?.name === 'MultiplayerResults';
}
